import Banner from "./Banner"
import About from "./About"
import CourseArea from "./CourseArea"
import Features from "./Features"
import Blog from "./Blog"
import HeaderOne from "../../../layouts/headers/HeaderOne"
import FooterOne from "../../../layouts/footers/FooterOne"
import Feature from "../home-one/Feature"
import PromoBanner from "../../../pages/PromoBanner"
import { useState, useEffect } from "react"
import API_BASE_URL from "../../../constants/api"
import axios from "axios"
type WeeklyClassResponse = {
  id: number;
  class_date: string;
  day_of_week: string;
  class_url: string;
  topic: string;
  is_active: boolean;
};


const HomeOne = () => {

   const [classData, setClassData] = useState<WeeklyClassResponse | null>(null);

  useEffect(() => {
    const fetchWeeklyClass = async () => {
      try {
        const res = await axios.get<WeeklyClassResponse>(`${API_BASE_URL}weekly-class`);
        setClassData(res.data);
      } catch (err) {
        console.error('Error fetching weekly class:', err);
      }
    };

    fetchWeeklyClass();
  }, []);
   return (
      <>
 
         <HeaderOne />
         <main className="main-area fix">
    
         {classData && <PromoBanner classData={classData} />}


            <Banner />
                  <About />
            {/* <Categories /> */}
            <Feature style={false}/>
            {/* <BrandOne /> */}
      
            <CourseArea style={false} />
            {/* <Newsletter /> */}
            {/* <Instructor /> */}
            {/* <Counter /> */}
            {/* <FaqArea /> */}
            <Features  />
            {/* <InstructorTwo style={false} /> */}
            <Blog style={false} />
         </main>
         <FooterOne style={false} style_2={false} />
      </>
   )
}

export default HomeOne
